















import { Component, Prop, Vue, Emit } from 'vue-property-decorator';
import findComponent from '@/params/components/findComponent';
import { createType, getTypeDef } from '@polkadot/types';
import registry from '@/params/components/typeRegistry';

@Component({
  name: 'ArgumentHandler',
})
export default class ArgumentHandler extends Vue {
  @Prop() public argument!: any;
  @Prop({ default: false }) public readonly disabled!: boolean;
  @Prop({ default: null }) public readonly defaultValue!: boolean;
  @Prop({ default: false }) public readonly actionVisible!: boolean;

  public enhanceTypeDef(argument: any) {
    console.log(argument.type);

    try {
      const type = createType(registry, argument.type).toRawType()
      return this.typeDefOf(argument, type);
    } catch (error) {
      console.warn(error)
      return this.typeDefOf(argument, argument.type)
    }

  }

  private typeDefOf(argument: any, type: any) {
    return {
      ...getTypeDef(type),
      ...argument,
    };
  }

  public selected(argument: any) {
    const component = findComponent(argument);
    return component;
  }

  @Emit('selected')
  private handleSelected(value: any) {
    console.log('ArgumentHandler', value);
    return value;
  }

  @Emit('action')
  private handleAction() {
    return this.argument.name
  }
}
